import React, { useState, useRef, useEffect } from "react";
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { ToastContainer, toast } from 'react-toastify';
import ContentLoader from "react-content-loader";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import Form from "react-validation/build/form";

import { getTrans as t } from "../../../../Localization/translations";
import EditNotificationService from "../../../../services/party/notification/editNotificationService";
import ButtonLoading from "../../../../components/Loder/buttonLoading";

function EditNotification({ id, notification, setHideShowNotifyEdit }) {

  const [notification_reminder, setNotification_reminder] = useState("")
  const [notification_type, setNotification_type] = useState("")
  const [notification_days, setNotification_days] = useState(30)
  const [to_email, setTo_email] = useState("")
  const [enable, setEnable] = useState()
  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const checkBtn = useRef();
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const form = useRef();

  const handleCancel = () => {
    // setHideShowEdit(true)
    setHideShowNotifyEdit(false)
  }

  useEffect(() => {
    setIsLoading(true)
    EditNotificationService.getPartyNotificationDetails(notification).then(
      (response) => {
        setNotification_reminder(response.data.notification_reminder)
        setNotification_type(response.data.notification_type)
        setNotification_days(response.data.notification_days)
        setTo_email(response.data.to_email)
        setEnable(response.data.enable)
        // setTimeout(() => {
        // }, 1000);
        reset({
          notification_reminder: response.data.notification_reminder,
          notification_type: response.data.notification_type,
          notification_days: response.data.notification_days,
          to_email: response.data.to_email,
          enable: response.data.enable,
        })
        setIsLoading(false)

      },
    )
  }, [])

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true)
    setDisable(true)
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditNotificationService.editPartyNotificationDetails(
        notification,
        notification_reminder,
        notification_type,
        notification_days,
        to_email,
        enable,
      ).then(
        (response) => {
          if (response.data.success) {
            setSuccessful(true);
            setLoading(false)
            setTimeout(() => {
              // setHideShowEdit(true)
              setHideShowNotifyEdit(false)
            }, 2000)
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
          }
          else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            setSuccessful(false);
            setDisable(false)

          }
        },
      )
    }
  }


  return (
    <>
      {/* {
        hideshowedit === false ? */}
      <div className="container-fluid">
        <ToastContainer />
        <div className="header">
          <h5 className="mb-2 pt-3">{t('Edit Notification')}</h5>
        </div>
        <div className="card" role="document">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                {isLoading !== true ?
                  <Form role="form text-left"
                    onSubmit={handleSubmit(handleRegister)}
                    ref={form}
                    action="."
                    method="POST"
                    id="addPartyContactForm" >
                    {(
                      <>
                        <div className="form-group row">
                          <div className="col-md-3">
                            <label className="col-form-label required">{t('Notification')} <Tooltip content={t("Notification_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <select
                              className="form-control form-select"
                              name="notification"
                              value={notification_reminder}
                              id="id_notification"
                              {...register("notification_reminder", { onChange: (e) => { setNotification_reminder(e.target.value) }, required: true })}
                            >
                              <option value="" selected="">
                                {t('Select Notification Reminder ')}
                              </option>
                              <option value="Due Date Reminder">
                                {t('Due Date Reminder')}
                              </option>
                              <option value="Email Invoice">
                                {t('Email Invoice')}
                              </option>
                              <option value="Past Due">
                                {t('Past Due')}
                              </option>
                            </select>
                            <div className="invalid-feedback">
                              {errors.notification_reminder?.type === 'required' && "Notification Reminder is required"}
                            </div>
                          </div>
                          <div className="col-md-3">
                            <label className="col-form-label required">{t('Type')} <Tooltip content={t('Type_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <select
                              className="form-control form-select"
                              name="notification_type"
                              value={notification_type}
                              id="id_notification"
                              {...register("notification_type", { onChange: (e) => { setNotification_type(e.target.value) }, required: true })}
                            >
                              <option value="" selected="">
                                Select Notification Type
                              </option>
                              <option value="Email" >
                                Email
                              </option>
                            </select>
                            <div className="invalid-feedback">
                              {errors.notification_type?.type === 'required' && "Notification Type is required"}
                            </div>
                          </div>
                          {notification_reminder !== "Email Invoice" &&
                            <div className="col-md-3">
                              <label className="col-form-label required">
                                {notification_reminder === 'Past Due' ? t("Days Past Due") : t("Days In Advance")}
                                <Tooltip content={notification_reminder === 'Past Due' ? t("DaysPastDue_Tooltip") : t("DaysInAdvance_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                value={notification_days}
                                type="number"
                                name="notification_days"
                                className="form-control no-spinner"
                                id="notification_days"
                                // disabled
                                placeholder={notification_reminder === 'Past Due' ? t("Days Past Due") : t("Days In Advance")}
                                {...register("notification_days",
                                  {
                                    validate: {
                                      positive: (v) =>
                                        parseInt(v) > -1 || "Enter Notification Days Positive Value",
                                    },
                                    onChange: (e) => { setNotification_days(e.target.value) },
                                    required: "Notification Days is required"
                                  })}
                              />
                              <div className="invalid-feedback">
                                {errors.notification_days?.message}
                              </div>
                            </div>
                          }

                          <div className="col-md-3">
                            <label className="col-form-label required">{t('To')} <Tooltip content={t('To_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              value={to_email}
                              type="email"
                              name="to_email"
                              className="form-control"
                              id="to_email"
                              placeholder="Enter Email"
                              {...register("to_email", { onChange: (e) => { setTo_email(e.target.value) }, required: true })}
                            />
                            <div className="invalid-feedback">
                              {errors.to_email?.type === 'required' && "Email is required"}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label className="col-form-label">{t('Enable')} <Tooltip content={t("Enable_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <div className="form-group row">

                              <div className="form-check" style={{ width: "50%", paddingLeft: "2.90em" }}>
                                <input
                                  className="form-check-input"
                                  value="1"
                                  checked={String(enable) === "1"}
                                  type="radio"
                                  name="enable"
                                  id="flexRadioDefault1"
                                  onChange={(e) => setEnable(e.target.value)}
                                />
                                <label className="form-check-label" htmlFor="flexRadioDefault1">
                                  Yes
                                </label>
                              </div>
                              <div className="form-check" style={{ width: "50%", paddingLeft: "3em" }}>
                                <input className="form-check-input"
                                  value="0"
                                  checked={String(enable) === "0"}
                                  type="radio"
                                  name="enable"
                                  id="flexRadioDefault1"
                                  onChange={(e) => setEnable(e.target.value)}
                                />
                                <label className="form-check-label" htmlFor="flexRadioDefault1">
                                  No
                                </label>
                              </div>
                            </div>
                            <div className="invalid-feedback">
                              {errors.enable?.type === 'required' && "Enable is required"}
                            </div>
                          </div>
                        </div>
                        <div className="text-left py-3">
                          <button type="button" className="btn btn-secondary btn-md" data-bs-dismiss="modal" onClick={handleCancel}>{t('cancel')}</button>&nbsp;
                          <button type="submit" disabled={disable} className="border-0 btn btn-primary btn-gradient-primary btn-md">
                            {
                              loading === false ? (
                                // t('Save')
                                t('Update')
                              ) : (
                                <ButtonLoading />
                              )
                            }
                          </button>&nbsp;
                        </div>
                      </>
                    )}
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                  </Form> :
                  <ContentLoader
                    viewBox="0 0 1000 550"
                    backgroundColor="rgba(0,0,0,0.06)"
                    foregroundColor="rgba(0,0,0,0.12)"
                  >
                    <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                    <circle cx="879" cy="123" r="11" />
                    <circle cx="914" cy="123" r="11" />
                    <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                    <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
                    <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
                    <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                    <circle cx="880" cy="184" r="11" />
                    <circle cx="915" cy="184" r="11" />
                    <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
                    <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
                    <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
                    <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="242" r="11" />
                    <circle cx="916" cy="242" r="11" />
                    <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
                    <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
                    <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
                    <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="303" r="11" />
                    <circle cx="917" cy="303" r="11" />
                    <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
                    <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
                    <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
                    <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="363" r="11" />
                    <circle cx="916" cy="363" r="11" />
                    <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
                    <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
                    <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
                    <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="424" r="11" />
                    <circle cx="917" cy="424" r="11" />
                    <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
                    <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
                    <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
                    <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                    <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                    <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                    <circle cx="882" cy="484" r="11" />
                    <circle cx="917" cy="484" r="11" />
                    <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
                    <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
                    <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
                    <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                    <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                    <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                    <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                    <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                    <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                    <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                  </ContentLoader>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* :
          <ManageNotification id={id} />
      } */}
    </>
  )
}

export default EditNotification
